import {
  Box, FormControl as ChakraFormControl, VStack
} from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import type { SingleValue } from 'react-select'
import { IKReactSelect } from '../../../../ui-kit'
import { fileTypeOptionsMapping } from '../../../../utils/mediaLibrary'
import { FileType } from '../../../constants'
import { FileTypeStateObject } from '../../../interfaces'


const FileTypeInputForm = (props: {
  fileType: FileTypeStateObject
  setFileType(fileType: FileTypeStateObject): void
}): React.ReactElement => {
  const {
    fileType,
    setFileType,
  } = props
  const { t } = useTranslation()

  return (
    <ChakraFormControl width="full">
      <VStack width="full" spacing="0.5em">
        <Box width="full">
          <IKReactSelect
            menuPlacement='auto'
            placeholder={t('select_an_option', 'Select an option')}
            variant="compact"
            isSearchable={false}
            options={Object.entries(fileTypeOptionsMapping).map(([key, value]) => ({
              label: t(value),
              value: key,
            }))}
            value={fileType.value === "" ? null : {
              label: fileType.text,
              value: fileType.value,
            }}
            onChange={(
              newVal: SingleValue<{
                label: string
                value: string
              }>,
            ) => {
              if (newVal) {
                setFileType({ text: t(fileTypeOptionsMapping[newVal.value]), value: newVal.value as FileType })
              }
            }}
          />
        </Box>
      </VStack>
    </ChakraFormControl>
  )
}

export default FileTypeInputForm
